module.exports = __webpack_public_path__ + "img/img.94d96a4e.png";